export default __webpack_public_path__ + "static/program_4-a93e171dd3675ab1b3c8bf30e79fb033.png";